import { render } from "./UnderstandingDigu.vue?vue&type=template&id=b1d4719e&scoped=true"
import script from "./UnderstandingDigu.vue?vue&type=script&lang=js"
export * from "./UnderstandingDigu.vue?vue&type=script&lang=js"

import "./UnderstandingDigu.vue?vue&type=style&index=0&id=b1d4719e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1d4719e"]])

export default __exports__